import React from 'react'
import View from '../../components/assessment'
import './assessment.styl'

export default function Assessment() {
    return (<View />)
}
